import { render, staticRenderFns } from "./ProjectUserSettings.vue?vue&type=template&id=8ee707de&scoped=true"
import script from "./ProjectUserSettings.vue?vue&type=script&lang=js"
export * from "./ProjectUserSettings.vue?vue&type=script&lang=js"
import style0 from "./ProjectUserSettings.vue?vue&type=style&index=0&id=8ee707de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee707de",
  null
  
)

export default component.exports